import React from "react";
import IndustryPage from "./IndustryPage";

const GovernmentPage: React.FC = () => {
  return <IndustryPage industryKey="government" />;
};

export default GovernmentPage;
